
import {Component, Emit, Mixins, Vue} from 'vue-property-decorator';
import CatalogEntryMixin from 'src/modules/catalog/components/cards/CatalogEntryMixin';
import ProgressIndicator from 'src/modules/catalog/components/cards/indicators/ProgressIndicator.vue';
import {songService} from 'src/modules/playable/SongService';
import {MiniPlayerConfig} from "/src/modules/global/mixins/MiniPlayerConfig";
import {defaultActives, defaultVolumes, SoundParameters} from 'src/modules/player/models/parameters/SoundParameters';
import CatalogMiniature from 'src/modules/catalog/components/cards/parts/CatalogMiniature.vue';
import {getScoreDescription} from 'src/modules/masteries/MasteriesUtils';
import DifficultyIndicator from 'src/modules/catalog/components/cards/indicators/DifficultyIndicator.vue';
import ScoreIndicator from 'src/modules/catalog/components/cards/indicators/ScoreIndicator.vue';
import {openSubscribePage} from 'src/utils/NavigationUtils';
import TeacherNotice from 'src/modules/teacher/TeacherNotice.vue';
import CatalogMiniatureWithInformation from 'src/modules/catalog/components/cards/parts/CatalogMiniatureWithInformation.vue';
import {challengeService} from 'src/modules/playable/ChallengeService';
import MiniPlayerMixin from 'src/modules/global/mixins/MiniPlayerMixin';
import {userService} from 'src/modules/user/UserService';
import {homeController} from '../../HomeController';

@Component({
  methods: {
  openSubscribePage,
  },
  components: {
  CatalogMiniatureWithInformation,
  TeacherNotice,
  ScoreIndicator,
  DifficultyIndicator,
  CatalogMiniature,
  ProgressIndicator,
  },
  })
export default class CatalogEntryPopup extends Mixins(MiniPlayerMixin) {
  private isDisplayed: boolean = false;
  private catalogEntryMixin: CatalogEntryMixin | null = null;
  private allowPreview = true;

  public show(catalogEntry: CatalogEntryMixin, allowPreview: boolean = true) {
    this.catalogEntryMixin = catalogEntry;
    this.allowPreview = allowPreview;
    this.$nextTick(() => (this.isDisplayed = true));

    if (allowPreview) {
      const defaultSoundParameters = new SoundParameters(defaultActives, defaultVolumes);
      if (this.catalogEntryMixin.isChallenge) {
        challengeService.loadChallenge(this.catalogEntryMixin.catalogEntry.id, false).then(() => {
          this.load(
            new MiniPlayerConfig(
              challengeService.state.challengeDivisions,
              challengeService.state.currentChallenge,
              defaultSoundParameters
            )
          );
        });
      }
      else {
        songService.loadVersion(this.catalogEntryMixin.catalogEntry.id).then(() => {
          this.load(
            new MiniPlayerConfig(songService.state.divisions, songService.state.currentVersion, defaultSoundParameters)
          );
        });
      }
    }
  }

  private onCloseDialog() {
    this.isDisplayed = false;
    this.catalogEntryMixin = null;
    this.close();
  }

  get handName() {
    return this.catalogEntryMixin.catalogEntry.config.hand_type === 'BOTH_HAND'
      ? 'à deux mains'
      : this.catalogEntryMixin.catalogEntry.config.hand_type === 'RIGHT_HAND'
        ? 'main droite'
        : 'main gauche';
  }
  get teacherNotice() {
    if (this.catalogEntryMixin.progress < 100) {
      return this.scoreDescription;
    }
    else {
      return "Bravo ! Vous maitrisez ce morceau. N'hésitez pas à le rejouer de temps en temps pour ne pas l'oublier !";
    }
  }
  get scoreDescription() {
    return getScoreDescription(
      this.catalogEntryMixin.songScore,
      this.catalogEntryMixin.currentDifficulty,
      this.isVersionNotInteresting,
      this.catalogEntryMixin.isChallenge ? 'challenge' : 'morceau',
      this.catalogEntryMixin.progress
    );
  }

  get showAsActionPopup() {
    return this.$q.screen.gt.sm || this.$q.screen.width < this.$q.screen.height;
  }

  get isAlreadyInPieceCourses() {
    return userService.user.configurations.pieceCourseIds.includes(this.catalogEntryMixin.catalogEntry.id);
  }

  get isVersionRecommended() {
    return !this.catalogEntryMixin.isChallenge && homeController.state.pieceRecommendations.some((el) => el.id === this.catalogEntryMixin?.catalogEntry.id);
  }

  get isVersionNotInteresting() {
    return !this.catalogEntryMixin.isChallenge && userService.user.configurations.notInterestingVersions.includes(this.catalogEntryMixin.catalogEntry.id)
  }

  markAsInterest() {
    const notInterestingVersions = userService.user.configurations.notInterestingVersions
    notInterestingVersions.push(this.catalogEntryMixin.catalogEntry.id)
    userService.updateConfiguration('NOT_INTERESTING_VERSIONS', notInterestingVersions).then(() => {
      homeController.loadUserVersions();
      this.onCloseDialog()
    })
  }

  addToPieceCourses() {
    const pieceCourseIds = userService.user.configurations.pieceCourseIds;
    pieceCourseIds.push(this.catalogEntryMixin.catalogEntry.id);
    userService.updateConfiguration('PIECE_COURSES', pieceCourseIds);
  }
}
